import { COLORS } from '@constants';
import { Icon } from '@ui';
import styled from 'styled-components';

export const CommissionIcon = styled(Icon.InfoFilledIcon)`
    &:hover {
        color: ${COLORS.$gray80Black};
        cursor: pointer;
    }
`;
